import * as actions_service_requests from 'actions/service-requests-actions';
import * as actions_users from 'actions/users-actions';
import * as toolbox from 'components/common/toolbox';
import React, { useEffect, useState } from 'react';
import ResultsActionIcons from './results-actions/results-action-icons';
import _ from 'lodash';
import { APPS, REQUESTS, SERVICE_REQUEST_TERMS } from 'components/constants';
import { Avatar } from 'enspire-manager-framework';
import { DashboardDetail, Spinner } from 'enspire-manager-framework';
import { Table } from 'em-table';
import { imageSize, navMultipleUrls, numPanels } from 'components/common/toolbox';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

const moment = require('moment');

const ResultsServiceRequests = (props) => {
    
    /* Hooks --------------------------*/
    
    const params = useParams();
    const history = useHistory();
    const dispatch = useDispatch();
	const routeLocation = useLocation();

    const employees = useSelector((store) => store.employees.employees);
    const serviceRequests = useSelector((store) => store.serviceRequests);
    const user = useSelector((store) => store.users.user);

    const [data, setData] = useState([]);

    const type = (params.appId == APPS.DISPATCH.id) ? 'service_request' : 'asset_request';
    const typeServiceRequests = _.filter(serviceRequests.service_requests_dashboard, (sr) => sr['type'] == type); 
    const orderedServiceRequests = _.orderBy(typeServiceRequests, [(params.appId == APPS.DISPATCH.id) ? '_displayName' : '_name'], ['asc']);
	const segments = routeLocation.pathname.split('/').length;

    /* UseEffect --------------------------*/

    useEffect(() => {
        if (params.widget_id == 'dashboard') {
            dispatch(actions_service_requests.clearDashboardServiceRequests());
        } else {
            dispatch(actions_service_requests.subDashboardServiceRequests(params.handle, params.appId, params.widget_id));
        }
        
        return () => {
			const unsubscribe = serviceRequests.service_requests_dashboard_unsubscribe;
			if (typeof unsubscribe == 'function') unsubscribe();
		};
    }, [params.handle, params.appId, params.widget_id]);

    useEffect(() => { 
        var service_requests = [];
        var currentEntityId = null;
        orderedServiceRequests?.forEach((serviceRequest) => {

            const entityId = (params.appId == APPS.DISPATCH.id) ? serviceRequest.customerId : serviceRequest.assetId;
            const status = _.find(Object.values(REQUESTS), { id: serviceRequest.statusId });
            const owner = _.find(employees, (o) => o.contact?.email == serviceRequest?.ownerId);
            const ownerName = (owner?.contact) ? owner?.contact.firstName + ' ' + owner?.contact.lastName : serviceRequest?.ownerId;
            
            // Add grouip heading for customer or asset
            if (entityId != currentEntityId) {
                currentEntityId = entityId;
                service_requests.push({ ...serviceRequest,
                    status: status?.name,
                    _jsx:
                    <div className="result-header d-flex align-items-center justify-content-between p-2" style={{ backgroundColor: '#dddddd' }}>
                        <div role="button" onClick={() => openEntity(serviceRequest)}>
                            <Avatar className=""
                                color="white"
                                bgColor="saddleBrown"
                                size={45}
                                fontSize={'20px'}
                                name={(params.appId == APPS.DISPATCH.id) ? serviceRequest._displayName : serviceRequest._name}
                                image={imageSize(serviceRequest._imageUrl, 'sm')}
                                imageWidth={60}
                                border="4px solid white"
                                role={ (serviceRequest._imageUrl) ? "button" : null }
                                style={{ flexShrink: 0 }}
                            />
                        </div>
                        <div className="flex-grow-1">
                            <h2 className="ml-3 m-0 text-black font-weight-normal">{
                                ((params.appId == APPS.DISPATCH.id) ? serviceRequest._displayName : serviceRequest._name) + 
                                ((serviceRequest._unitNumber) ? ' #' + serviceRequest._unitNumber : '')
                            }</h2>
                            { serviceRequest._address &&
                                <p className="ml-3 m-0">{ serviceRequest._address }</p>
                            }
                        </div>
                    </div> 
                });
            }

            service_requests.push({ ...serviceRequest,
                status: status?.name,
                _stripe_color: status?.color,
                details: <div key={serviceRequest.id}>
                    <div className="d-flex justify-content-between">
                        <h1 className="main-heading heading-service-request align-self-start mx-2">
                            Service #{serviceRequest.customId}
                        </h1>
                        <p className="mb-2 mr-auto">{ moment(serviceRequest.requestDate?.toDate()).format('MMM Do, YYYY') }</p>
                    </div>
                    
                    <div id="work-order-details" className="mt-2 mb-2">
                        <DashboardDetail field={ 'Summary' } value={ serviceRequest.description } />
                        <DashboardDetail field={ 'Suggested' } value={ serviceRequest.suggested } type="text" />
                        <DashboardDetail field={ 'Total Cost' } value={ serviceRequest.totalCost } type="usd" />
                        <DashboardDetail field={ 'Created By' } value={ `${ownerName}` } type="text" />
                        <div className="clearfix"></div>
                    </div>
                    <div className="d-flex align-items-end justify-content-end">
                        <div className="d-flex align-items-center flex-wrap">
                            { serviceRequest?.reasons?.map((reason) => {
                                if (!reason.reason) return null;
                                return (
                                    <div className="alert alert-warning mb-0 mt-2">
                                        <strong>WO: #{reason.customId} INCOMPLETE:</strong>&nbsp; { reason.reason }
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-between">
                        <ResultsActionIcons entity={ 'serviceRequest' } entityId={ serviceRequest.id } serviceRequest={ serviceRequest } sms={ false } />
                        <button className="btn btn-default btn-lg btn-circle ml-3" onClick={ () => openServiceRequest(serviceRequest) }>
                            <i className="fa-duotone fa-solid fa-chevrons-right"></i>
                        </button>
                    </div>
                </div>
            });
        });
        setData(service_requests);
    }, [serviceRequests.service_requests_dashboard, routeLocation.pathname]);

    /* Actions ----------------------------*/

    const openServiceRequest = async (serviceRequest) => {
        let num = (segments >= 11) ? -2 : (segments >= 10) ? -1 : 0;
        if (num) history.go(num);

        const entityId = (params.appId == APPS.DISPATCH.id) ? serviceRequest.customerId : serviceRequest.assetId;
        const workOrderIds = await actions_service_requests.getWorkOrderIdsByServiceRequestId(params.handle, serviceRequest.id);

        if (serviceRequest.serviceRequestTermsId == SERVICE_REQUEST_TERMS.SERVICE_CALL.id) {
            navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests`, 7),
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${serviceRequest.id}/work_orders/${workOrderIds?.[0]}/items`, 11),
            ]});
        } else {
            navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
                toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests`, 7),
                ...(serviceRequest.serviceRequestTermsId == SERVICE_REQUEST_TERMS.PROJECT_QUOTE.id)
                ? [toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${serviceRequest.id}/quotes`, 9)]
                : [toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/service_requests/${serviceRequest.id}/work_orders`, 9)]
            ]});
        }
    }
    const openEntity = (serviceRequest) => {
        const entityId = (params.appId == APPS.DISPATCH.id) ? serviceRequest.customerId : serviceRequest.assetId;
        const tab = (params.appId == APPS.DISPATCH.id) ? 'tab' : 'service_requests';

        navMultipleUrls({ actions_users, dispatch, history, numPanels, params, user, urlArray: [
            toolbox.modifyPath( routeLocation?.pathname, 4, `${entityId}/form/0/${tab}`, 7),
        ]});    
    }

    /* Constants --------------------------*/

    const columns = [
        { name: 'Details', field: 'details', type: 'jsx', width: 100 },
    ];

    return (

        <>
            { serviceRequests.service_requests_dashboard_pending

                ?   <div className="bg-white p-4 mt-2">
                        <Spinner />
                    </div>
                :   <Table
                        data={data}
                        columns={columns}
                        active_field={'id'}
                        active_id={params.tab1_id}
                        hide_header={true}
                    />
            }
        </>
    );
};

export default ResultsServiceRequests;